/** Chromium / Acrobat-style fragment to hide thumbnail sidebar in embedded PDFs. */
export function invoicePdfIframeSrc(objectUrl: string): string {
  const params = "navpanes=0&pagemode=none&view=FitH";
  if (objectUrl.includes("#")) {
    return `${objectUrl}&${params}`;
  }
  return `${objectUrl}#${params}`;
}
